import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getWheelsParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'wheelsParts';

export const wheelsPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearWheelsParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getWheelsParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearWheelsParts } = wheelsPartsSlice.actions;

export const wheelsParts = wheelsPartsSlice.reducer;
